import { apiRequest } from "./client";

const base = (guildId) => `/api/v1/guilds/${guildId}/automod`;

export const getAutomodWhitelist = (guildId) => apiRequest(`${base(guildId)}/whitelist`);
export const addAutomodWhitelist = (guildId, payload) =>
  apiRequest(`${base(guildId)}/whitelist`, { method: "POST", body: payload });
export const removeAutomodWhitelist = (guildId, payload) =>
  apiRequest(`${base(guildId)}/whitelist`, { method: "DELETE", body: payload });

export const getModuleWhitelist = (guildId) => apiRequest(`${base(guildId)}/module-whitelist`);
export const addModuleWhitelist = (guildId, payload) =>
  apiRequest(`${base(guildId)}/module-whitelist`, { method: "POST", body: payload });
export const removeModuleWhitelist = (guildId, payload) =>
  apiRequest(`${base(guildId)}/module-whitelist`, { method: "DELETE", body: payload });
